import React from 'react';
import PropTypes from 'prop-types';

const Start = ({ isActive }) => (
  <svg height="24px" viewBox="0 -960 960 960" width="24px">
    {isActive && (
      <path
        fill="var(--color-green65)"
        d="m325-676.31 155-206.23 155 206.23 245.54 82.77-157.62 213.46 6.23 242.23L480-210.69l-249.15 72.84 6.23-243.23L80.46-593.54 325-676.31Z"
      />
    )}
    <path
      fill="var(--color-grey97)"
      d="m325-676.31 155-206.23 155 206.23 245.54 82.77-157.62 213.46 6.23 242.23L480-210.69l-249.15 72.84 6.23-243.23L80.46-593.54 325-676.31Zm25.15 34.39-204 69.38 131.7 179.77-5.54 200.23L480-252.15l207.69 61.38-5.54-202 131.7-177.77-204-71.38L480-815.38 350.15-641.92ZM480-503.08Z"
    />
  </svg>
);

Start.defaultProps = { isActive: false };
Start.propTypes = { isActive: PropTypes.bool };

export default Start;
